<template>
	<section class="section_comment">
		<div class="comment_header">
			<h4 class="header_title">댓글({{ props.counts }})</h4>
		</div>
		<div class="comment_inputArea">
			<div class="textArea_wrap">
				<div class="inputArea_textArea c_textarea">
					{{ INPUT_COMMENT }}
				</div>
				<!-- <span class="count">{{ commentValue.length }}/1000</span> -->
			</div>
			<div class="inputArea_btnArea"><button type="button" disabled>작성</button></div>
		</div>

		<ul class="comment_list">
			<div v-for="item in props.comments" :key="item.comment.comment_pk">
				<li class="list_item">
					<div class="item_meta">
						<span class="meta_writer">{{ item?.comment.member_nickname }}</span>
						<span class="meta_date">{{ removeSecondsFromTime(item?.comment.comment_enrollment_date) }}</span>
					</div>
					<p class="item_content">{{ item?.comment.comment_content }}</p>
					<div class="item_btn">
						<div v-if="!item?.comment.is_mine">
							<span class="cursor-pointer" @click="replyComment(item?.comment.comment_pk)">답글</span>
						</div>
						<div v-if="item?.comment.is_mine">
							<span class="cursor-pointer" @click="replyComment(item?.comment.comment_pk)">답글</span>
							<span>|</span>
							<span
								class="cursor-pointer"
								@click="editComment(item?.comment.comment_pk, String(item?.comment.comment_content))"
								>수정</span
							>
							<span>|</span>
							<span class="cursor-pointer" @click="onClickDeleteComment(item?.comment.comment_pk)">삭제</span>
						</div>
					</div>
				</li>
				<div v-if="depthTwoInputState === 'REPLY' && selectedCommentPk === item?.comment.comment_pk">
					<div class="comment_inputArea">
						<div class="textArea_wrap">
							<div class="inputArea_textArea c_textarea">{{ INPUT_COMMENT }}</div>
							<!-- <span class="count">{{ replyValue.length }}/1000</span> -->
						</div>
						<div class="inputArea_btnArea">
							<button type="button" disabled>작성</button>
						</div>
					</div>
				</div>
				<div v-if="depthTwoInputState === 'EDIT' && selectedCommentPk === item?.comment.comment_pk">
					<div class="comment_inputArea">
						<div class="textArea_wrap">
							<div class="inputArea_textArea c_textarea">{{ INPUT_COMMENT }}</div>
							<!-- <span class="count">{{ editCommentValue.length }}/1000</span> -->
						</div>
						<div class="inputArea_btnArea">
							<button type="button" disabled>저장</button>
						</div>
					</div>
				</div>
				<div v-if="item?.replies" class="reply_container">
					<ul v-for="replyItem in item.replies" :key="replyItem?.comment_pk">
						<div>
							<div class="reply_icon">
								<img src="@/assets/img/common/reply.svg" alt="답글" loading="lazy" />
							</div>
							<li class="list_item-reply">
								<div class="item_meta-reply">
									<span class="meta_writer-reply">{{ replyItem?.member_nickname }}</span>
									<span class="meta_date-reply">{{ removeSecondsFromTime(replyItem?.comment_enrollment_date) }}</span>
								</div>
								<p class="item_content-reply">{{ replyItem?.comment_content }}</p>
								<div class="item_btn-reply">
									<div v-if="replyItem?.is_mine">
										<span
											class="cursor-pointer"
											@click="editReply(replyItem?.comment_pk, String(replyItem?.comment_content))"
											>수정</span
										>
										<span>|</span>
										<span class="cursor-pointer" @click="onClickDeleteComment(replyItem?.comment_pk)">삭제</span>
									</div>
								</div>
							</li>
						</div>
						<div v-if="depthThreeInputState && selectedReplyPk === replyItem?.comment_pk">
							<div class="comment_inputArea-reply">
								<div class="textArea_wrap">
									<div class="inputArea_textArea-reply c_textarea">{{ INPUT_COMMENT }}</div>
									<!-- <span class="count">{{ editReplyValue.length }}/1000</span> -->
								</div>
								<div class="inputArea_btnArea-reply">
									<button type="button" disabled>저장</button>
								</div>
							</div>
						</div>
					</ul>
				</div>
			</div>
		</ul>
	</section>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { CommentWithReplies, useDeleteCommentApi } from '@/api/comment';
import {
	COMPANY_TITLE,
	CONFIRM,
	CONFIRM_DELETE_ITEM,
	INPUT_COMMENT,
	MESSAGE_DELETE_COMPLETED,
} from '@/constants/title';
// import { useRouter } from 'vue-router';
import { usePopupStore } from '@/stores/popup';
import { useToastStore } from '@/stores/toast';
import { useTokenStore } from '@/stores/token';
import { checkLoginDetail } from '@/utils/function/login';

// -----variable-----
const props = defineProps<{
	comments: CommentWithReplies[];
	counts: number;
	board: string;
}>();

// const router = useRouter();
// const route = useRoute();
const popupStore = usePopupStore();
const toastStore = useToastStore();
const tokenStore = useTokenStore();
const selectedCommentPk = ref(-1);
const selectedReplyPk = ref(-1);
const depthTwoInputState = ref('');
const depthThreeInputState = ref(false);
const editCommentValue = ref('');
const replyValue = ref('');
const editReplyValue = ref('');

// -----api-----
// const { mutateAsync: saveComment } = useSaveComment();
const { mutateAsync: deleteComment } = useDeleteCommentApi();

// -----function-----
// ~인터렉션 함수~
// 답글 작성 시
const replyComment = (pk: number) => {
	if (!tokenStore.isLogin) {
		checkLoginDetail();
		return;
	}
	if (depthTwoInputState.value === '') {
		depthTwoInputState.value = 'REPLY';
		selectedCommentPk.value = pk;
	} else {
		depthTwoInputState.value = '';
		selectedCommentPk.value = -1;
		replyValue.value = '';
	}
};
// 댓글 수정 시
const editComment = (pk: number, content: string) => {
	if (!tokenStore.isLogin) {
		checkLoginDetail();
		return;
	}
	if (depthTwoInputState.value === '') {
		depthTwoInputState.value = 'EDIT';
		selectedCommentPk.value = pk;
		editCommentValue.value = content;
	} else {
		depthTwoInputState.value = '';
		selectedCommentPk.value = -1;
		editCommentValue.value = '';
	}
};
// 답글 수정 시
const editReply = (pk: number, content: string) => {
	if (!tokenStore.isLogin) {
		checkLoginDetail();
		return;
	}
	depthThreeInputState.value = !depthThreeInputState.value;
	if (depthThreeInputState.value) {
		selectedReplyPk.value = pk;
		editReplyValue.value = content;
	} else {
		selectedReplyPk.value = -1;
		editReplyValue.value = '';
	}
};
// ~API 호출 함수~
// 댓글 저장 api 호출 함수
// type Params = {
// 	board: string;
// 	comment_content: string;
// 	knowhow_pk?: number;
// 	notice_pk?: number;
// 	master_pk?: number;
// 	upper_comment_pk?: number;
// 	comment_pk?: number;
// };
// 댓글 등록 기능 8월 14일 자본시장법으로 인한 숨김처리
// const onClickSaveComment = async () => {
// 	if (!tokenStore.isLogin) {
// 		loginPopupStore.openPopup({
// 			icon: 'alert',
// 			content: LOGIN_REQUIRED_PAGE,
// 			confirm: () => router.push('/auth/login'),
// 			confirmText: CONFIRM_LOGIN,
// 			cancelText: CANCEL,
// 		});
// 		return;
// 	}
// 	if (!commentValue.value) {
// 		popupStore.openPopup({
// 			content: COMPANY_TITLE,
// 			subtext: INPUT_CONTENTS,
// 		});
// 		return;
// 	}
// 	const params: Params = {
// 		board: props.board,
// 		comment_content: commentValue.value,
// 	};
// 	switch (props.board) {
// 		case 'knowhow':
// 			params.knowhow_pk = Number(route.params.pk);
// 			break;
// 		case 'notice':
// 			params.notice_pk = Number(route.params.pk);
// 			break;
// 		case 'master':
// 			params.master_pk = Number(route.params.pk);
// 			break;
// 	}
// 	await saveComment(params);

// 	commentValue.value = '';
// 	emit('update:comment');
// };
// 답글 저장 api 호출 함수
// const onClickSaveReply = async (upperCommentPk: number) => {
// 	if (!tokenStore.isLogin) {
// 		loginPopupStore.openPopup({
// 			icon: 'alert',
// 			content: LOGIN_REQUIRED_PAGE,
// 			confirm: () => router.push('/auth/login'),
// 			confirmText: CONFIRM_LOGIN,
// 			cancelText: CANCEL,
// 		});
// 		return;
// 	}
// 	if (!replyValue.value) {
// 		popupStore.openPopup({
// 			content: COMPANY_TITLE,
// 			subtext: INPUT_CONTENTS,
// 		});
// 		return;
// 	}
// 	const params: Params = {
// 		board: props.board,
// 		comment_content: replyValue.value,
// 		upper_comment_pk: upperCommentPk,
// 	};
// 	switch (props.board) {
// 		case 'knowhow':
// 			params.knowhow_pk = Number(route.params.pk);
// 			break;
// 		case 'notice':
// 			params.notice_pk = Number(route.params.pk);
// 			break;
// 		case 'master':
// 			params.master_pk = Number(route.params.pk);
// 			break;
// 	}
// 	await saveComment(params);

// 	depthTwoInputState.value = '';
// 	replyValue.value = '';
// 	emit('update:comment');
// };
// 댓글 수정 api 호출 함수
// const onClickEditComment = async (commentPk: number) => {
// 	if (!tokenStore.isLogin) {
// 		loginPopupStore.openPopup({
// 			icon: 'alert',
// 			content: LOGIN_REQUIRED_PAGE,
// 			confirm: () => router.push('/auth/login'),
// 			confirmText: CONFIRM_LOGIN,
// 			cancelText: CANCEL,
// 		});
// 		return;
// 	}
// 	if (!editCommentValue.value) {
// 		popupStore.openPopup({
// 			content: COMPANY_TITLE,
// 			subtext: INPUT_CONTENTS,
// 		});
// 		return;
// 	}
// 	const params: Params = {
// 		board: props.board,
// 		comment_content: editCommentValue.value,
// 		comment_pk: commentPk,
// 	};
// 	switch (props.board) {
// 		case 'knowhow':
// 			params.knowhow_pk = Number(route.params.pk);
// 			break;
// 		case 'notice':
// 			params.notice_pk = Number(route.params.pk);
// 			break;
// 		case 'master':
// 			params.master_pk = Number(route.params.pk);
// 			break;
// 	}
// 	await saveComment(params);

// 	depthTwoInputState.value = '';
// 	editCommentValue.value = '';
// 	emit('update:comment');
// };
// 답글 수정 api 호출 함수
// const onClickEditReply = async (commentPk: number, upperCommentPk: number | null) => {
// 	if (!tokenStore.isLogin) {
// 		loginPopupStore.openPopup({
// 			icon: 'alert',
// 			content: LOGIN_REQUIRED_PAGE,
// 			confirm: () => router.push('/auth/login'),
// 			confirmText: CONFIRM_LOGIN,
// 			cancelText: CANCEL,
// 		});
// 		return;
// 	}
// 	if (!editReplyValue.value) {
// 		popupStore.openPopup({
// 			content: COMPANY_TITLE,
// 			subtext: INPUT_CONTENTS,
// 		});
// 		return;
// 	}
// 	if (upperCommentPk) {
// 		const params: Params = {
// 			board: props.board,
// 			comment_pk: commentPk,
// 			comment_content: editReplyValue.value,
// 			upper_comment_pk: upperCommentPk,
// 		};
// 		switch (props.board) {
// 			case 'knowhow':
// 				params.knowhow_pk = Number(route.params.pk);
// 				break;
// 			case 'notice':
// 				params.notice_pk = Number(route.params.pk);
// 				break;
// 			case 'master':
// 				params.master_pk = Number(route.params.pk);
// 				break;
// 		}
// 		depthThreeInputState.value = false;
// 		editReplyValue.value = '';
// 		await saveComment(params);
// 	}

// 	depthTwoInputState.value = '';
// 	replyValue.value = '';

// 	commentValue.value = '';
// 	emit('update:comment');
// };
// 댓글 삭제 api 호출 함수
const onClickDeleteComment = (pk: number) => {
	if (!tokenStore.isLogin) {
		checkLoginDetail();
		return;
	}
	popupStore.openPopup({
		content: COMPANY_TITLE,
		subtext: CONFIRM_DELETE_ITEM,
		confirm: async () => {
			try {
				const params = {
					comment_pk: pk,
				};
				await deleteComment(params);

				toastStore.openToast({
					subContent: COMPANY_TITLE,
					content: MESSAGE_DELETE_COMPLETED,
				});
			} catch (error) {
				console.log(error);
			}
		},
		confirmText: CONFIRM,
	});
};
// ~기타함수~
// 시간에서 초단위 삭제하는 함수
const removeSecondsFromTime = (timestamp: string) => {
	const date = new Date(timestamp);
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	const hours = String(date.getHours()).padStart(2, '0');
	const minutes = String(date.getMinutes()).padStart(2, '0');
	const newTimestamp = `${year}-${month}-${day} ${hours}:${minutes}`;
	return newTimestamp;
};
</script>

<style scoped lang="scss">
.comment_list {
	.list_item {
		border-bottom: 1px solid #393d45;
		padding: 2rem 0;
		.item_meta {
			display: flex;
			gap: 0.8rem;
			font-size: var(--font-s-mid);
			line-height: 1.79rem;
			margin-bottom: 0.8rem;
			.meta_writer {
				font-weight: var(--font-w-bold);
			}
			.meta_date {
				font-weight: 400;
				color: #7d7d8d;
			}
		}
		.item_content {
			font-size: var(--font-s-regular);
			font-weight: var(--font-w-light);
			line-height: 2.3rem;
			overflow-wrap: break-word;
			margin-bottom: 1.6rem;
		}
		.item_btn {
			display: flex;
			justify-content: end;
			font-size: var(--font-s-mid);
			font-weight: var(--font-w-semi-bold);
			line-height: 1.79rem;
			color: #7d7d8d;
			div {
				display: flex;
				gap: 1.6rem;
			}
		}
	}
	.comment_inputArea {
		display: flex;
		flex-direction: column;
		gap: 1rem;
		position: relative;
		margin-bottom: 3.2rem;
		.inputArea_textArea {
			border: none;
			height: 13.4rem;
			color: #7d7d8d;
			&:focus {
				border: none;
				outline: none;
				-webkit-box-shadow: none;
				-moz-box-shadow: none;
				box-shadow: none;
			}
		}
		.inputArea_btnArea {
			width: 100%;
			display: flex;
			justify-content: end;
			button {
				font-size: var(--font-s-mid);
				font-weight: var(--font-w-semi-bold);
				line-height: 1.79rem;
				background-color: #ff5e00;
				padding: 0.95rem 1.6rem;
				border-radius: 0.6rem;
				&:disabled {
					background-color: var(--color-base-disabled);
					color: var(--color-base-light);
				}
			}
		}
	}
	.reply_container {
		ul {
			display: flex;
			flex-direction: column;
			padding: 2rem 0;
			border-bottom: 1px solid #393d45;
		}
		div {
			display: flex;
		}
		.reply_icon img {
			width: 1.6rem;
			height: 1.6rem;
			margin: 0 1.6rem;
		}
		.list_item-reply {
			width: 100%;
			.item_meta-reply {
				display: flex;
				gap: 0.8rem;
				font-size: var(--font-s-mid);
				line-height: 1.79rem;
				margin-bottom: 0.8rem;
				.meta_writer-reply {
					font-weight: var(--font-w-bold);
				}
				.meta_date-reply {
					font-weight: 400;
					color: #7d7d8d;
				}
			}
			.item_content-reply {
				font-size: var(--font-s-regular);
				font-weight: var(--font-w-light);
				line-height: 2.3rem;
				overflow-wrap: break-word;
				margin-bottom: 1.6rem;
			}
			.item_btn-reply {
				display: flex;
				justify-content: end;
				font-size: var(--font-s-mid);
				font-weight: var(--font-w-semi-bold);
				line-height: 1.79rem;
				color: #7d7d8d;
				div {
					display: flex;
					gap: 1.6rem;
				}
			}
		}
		.comment_inputArea-reply {
			display: flex;
			flex-direction: column;
			gap: 1rem;
			margin: 2rem 0 3.2rem;
			width: 100%;
			.inputArea_textArea-reply {
				border: none;
				height: 13.4rem;
				color: #7d7d8d;
				&:focus {
					border: none;
					outline: none;
					-webkit-box-shadow: none;
					-moz-box-shadow: none;
					box-shadow: none;
				}
			}
			.inputArea_btnArea-reply {
				width: 100%;
				display: flex;
				justify-content: end;
				button {
					font-size: var(--font-s-mid);
					font-weight: var(--font-w-semi-bold);
					line-height: 1.79rem;
					background-color: #ff5e00;
					padding: 0.95rem 1.6rem;
					border-radius: 0.6rem;
					&:disabled {
						background-color: var(--color-base-disabled);
						color: var(--color-base-light);
					}
				}
			}
		}
	}
}
.section_comment {
	.comment_header {
		margin-bottom: 1.6rem;
		.header_title {
			font-size: var(--font-s-x-large);
			font-weight: var(--font-w-bold);
			line-height: 2.387rem;
		}
	}
	.comment_inputArea {
		display: flex;
		flex-direction: column;
		gap: 1rem;
		margin-bottom: 3.2rem;
		.inputArea_textArea {
			border: none;
			height: 13.4rem;
			color: #7d7d8d;
			&:focus {
				border: none;
				outline: none;
				-webkit-box-shadow: none;
				-moz-box-shadow: none;
				box-shadow: none;
			}
		}
		.inputArea_btnArea {
			width: 100%;
			display: flex;
			justify-content: end;
			button {
				font-size: var(--font-s-mid);
				font-weight: var(--font-w-semi-bold);
				line-height: 1.79rem;
				background-color: #ff5e00;
				padding: 0.95rem 1.6rem;
				border-radius: 0.6rem;
				&:disabled {
					background-color: var(--color-base-disabled);
					color: var(--color-base-light);
				}
			}
		}
	}
}
.textArea_wrap {
	position: relative;
	border: 1px solid #818393;
	border-radius: 6px;
	height: 16.4rem;
	overflow: hidden;
	.count {
		font-size: var(--font-s-small);
		font-weight: var(--font-w-light);
		line-height: 1.551rem;
		color: var(--color-base-mid);
		position: absolute;
		bottom: 1.1rem;
		right: 1rem;
	}
}
</style>
